module.exports = __webpack_public_path__ + "static/media/MasterCard_Logo.1d13a168.svg";